import type { v4 } from '@sap/ux-specification-types';
import {
    type ToolBarAction,
    type CustomTableAction,
    type ToolBarActionGroup,
    CustomTableActionBase
} from './ToolBarAction';
import { syncRule, validity } from '../../../common';
import { getActionsPathForLR } from '../../application';
import { exportActionMenuAction, exportActionMenuDefaultAction } from '../actions';

export class Actions implements v4.Actions {
    [key: string]: ToolBarAction | CustomTableAction | CustomActionMenu | ToolBarActionGroup;
}

export class ToolBar implements v4.ToolBar {
    actions: Actions;
}

export class CustomActionMenu extends CustomTableActionBase implements v4.CustomActionMenu {
    @syncRule({
        manifest: {
            path: getActionsPathForLR,
            export: exportActionMenuAction
        }
    })
    @validity({
        since: '1.84.0'
    })
    actions?: CustomActionMenuActions;

    @syncRule({
        manifest: {
            path: getActionsPathForLR,
            export: exportActionMenuDefaultAction
        }
    })
    @validity({
        since: '1.84.0'
    })
    defaultAction?: string;
}

export class CustomActionMenuActions implements v4.CustomActionMenuActions {
    [id: string]: ToolBarAction | CustomTableAction | ToolBarActionGroup;
}
